export default "__VITE_ASSET__28966ccd__"